export class ApiURL {
  public static JobCard = '/assignments/parse-job-card'
  public static Assignments = '/assignments'
  public static Customer = '/companies'
  public static Languages = '/languages';
  public static Translations = '/translations';

}
